import React from "react"

interface LatestFirmwareCardProps {
	firmware: {
		version: string
		fileName: string
	}
}

const LatestFirmwareCard: React.FC<LatestFirmwareCardProps> = ({firmware}) => {
	return (
		<div className="bg-purple-50 p-4 rounded-lg border border-purple-200 mb-6">
			<h2 className="font-semibold mb-2 text-purple-900">Latest Radar Firmware</h2>
			<div className="text-sm text-purple-800">
				<div>Version: {firmware.version}</div>
				<div>File: {firmware.fileName}</div>
			</div>
		</div>
	)
}

export default LatestFirmwareCard
